module.exports = __webpack_public_path__ + "img/Homepage-Rabbit.9d71c566.svg";